import { AppAlertEventBus } from "@/app/shared/services/app-alert/app-alert";

const authContainerEventBus = new AppAlertEventBus();
export default authContainerEventBus;
